export default "__VITE_ASSET__ClGy9_tI__"